import script from "./ProvinceSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProvinceSelect.vue?vue&type=script&lang=ts&setup=true"

import "./ProvinceSelect.vue?vue&type=style&index=0&id=57709937&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57709937"]])

export default __exports__